export default function LongestStreak({ bestStreak = 0 }) {

  const colorClass = bestStreak < 7
    ? "bg-cyan-100 text-black shadow-sm"
    : "bg-yellow-100 text-black shadow-sm";

  const iconBg = bestStreak < 7
    ? "bg-cyan-400"
    : "bg-yellow-400";

  return (
    <>
    {/* preload for Tailwind */}
    <div className="bg-cyan-400 bg-yellow-500 text-cyan-400 text-yellow-500 border-cyan-400 border-yellow-500" />
    <div className={`flex items-center ${colorClass} rounded-full w-full`}>
      {/* Fire icon circle */}
      <div className={`w-10 h-10 ${iconBg} rounded-full flex items-center justify-center mr-3`}>
        <img
          src="/images/streak_cold_white.png"
          alt="Streak icon"
          className="w-5 h-5"
        />
      </div>
      {/* Text */}
      <span className="text-sm font-medium mr-4">
        længste streak: <span className="font-bold">{bestStreak} dage</span>
      </span>
    </div>
    </>
  );
}